module.exports = __webpack_public_path__ + "img/ricardo-pizzuto.54a880ca.png";